<!-- 转为采购订单（供应商）&& 采购订单编辑页 -->
<template>
    <div class="business-content-main" v-loading="loading">
        <div>
            <div class="bread-nav">
                <breadcrumb :canBackHistory="true"></breadcrumb>
            </div>
            <!--   订单信息     -->
            <div class="section-title">
                <div class="space-between">
                    <span>订单信息【{{orderData.OrderCode}}】</span>
                    <span v-if="isUseSource" style="display: inline-block;">订单来源：{{orderData.CusSourcesName}}</span>
                </div>
            </div>
            <div class="order-infoes">
                <el-form :model="orderData" ref="formMsg" label-width="90px" style="width: 100%; padding-right: 30px;padding-left: 30px">
                    <el-row :gutter="20">
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="选择供应商" prop="EntpCusId">
                                    <el-input size="small" disabled v-model="orderData.EntpCusName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="采购员" prop="SId">
                                    <el-input size="small" disabled v-model="orderData.SName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="发货方式">
                                    <el-input size="small" disabled v-model="orderData.ShipTypeName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content bg-purple">
                                <el-form-item label="运输费用" prop="ShipAmount">
                                    <el-input size="small" disabled v-model="orderData.ShipAmount"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="结算方式" prop="PayType">
                                    <el-input size="small" disabled v-model="orderData.PayTypeName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="5" v-if="isOrgShow">
                            <div class="grid-content bg-purple" style="width:100%">
                                <el-form-item label="部门" prop="OrgId">
                                    <el-input size="small" disabled v-model="orderData.OrgName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="入仓仓库" prop="WarehouseId">
                                    <el-input size="small" disabled :title="warehouseName" v-model="warehouseName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item label="仓库地址" prop="WarehouseAddr">
                                    <el-input size="small" disabled :title="WarehouseAddr" v-model="WarehouseAddr"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="grid-content bg-purple">
                                <el-form-item label="备注" style="width: 100%">
                                    <el-input size="small" style="width: 100%" :title="orderData.Remark" disabled v-model="orderData.Remark"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="5" v-if="orderImages.length > 0 && permission.flowVoucher">
                            <div class="form-uploadImg">
                                <div>流水单据：</div>
                                <el-upload
                                    action=""
                                    :file-list="orderImages"
                                    :disabled="true"
                                    list-type="picture-card"
                                    accept="image/jpeg, image/png"
                                    :on-preview="onUploadPreview"
                                    class="hideUpload"
                                >
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                                <el-dialog :visible.sync="dialogImageVisible">
                                    <img width="100%" :src="dialogImageUrl" alt="" />
                                </el-dialog>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <!--   付款记录     -->
            <div class="section-title">
                <div>付款记录</div>
            </div>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="paymentRecords"
                    border=""
                    show-summary
                    :summary-method="getSummaries_apply"
                    :max-height="250"
                    style="width: 100%; margin-bottom: 10px; margin-top: 0px"
                >
                    <el-table-column show-overflow-tooltip width="190px" prop="PayCode" label="流水号"></el-table-column>
                    <el-table-column show-overflow-tooltip width="150px" prop="SumPayable" label="订单总金额"></el-table-column>
                    <el-table-column show-overflow-tooltip width="150px" prop="ApplyPay" label="申请付款金额"></el-table-column>
                    <el-table-column show-overflow-tooltip width="150px" prop="NowPay" label="实付金额"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" prop="PayTypeName" label="结算方式">
                        <template slot-scope="scope">
                            <el-popover
                                placement="right"
                                width="400"
                                trigger="click"
                                v-if="
                                    (scope.row.PayType == '20' || scope.row.PayType == '25' || scope.row.PayType == '30' || scope.row.PayType == '35') &&
                                        (scope.row.Bank || scope.row.AccountName || scope.row.Account)
                                "
                            >
                                <div class="account-info">
                                    <span v-if="scope.row.Bank">
                                        {{ '开户行：' + scope.row.Bank }}
                                    </span>
                                    <span v-if="scope.row.AccountName">
                                        {{ '账户名：' + scope.row.AccountName }}
                                    </span>
                                    <span v-if="scope.row.Account">
                                        {{ '账号：' + scope.row.Account }}
                                    </span>
                                </div>
                                <i slot="reference" class="el-icon-info" style="font-size: 18px; color: #409eff" title="支付账号信息"></i>
                            </el-popover>
                            <span>{{ scope.row.PayTypeName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="80px" prop="ApplyName" label="申请人"></el-table-column>
                    <el-table-column show-overflow-tooltip width="160px" prop="CreateTime" label="申请时间"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="Remark" label="备注"></el-table-column>
                </el-table>
            </div>
            <!--    成本分摊 -- 操作记录    -->
            <el-row :gutter="20">
                <el-col :span="12">
                    <div class="grid-content">
                        <div class="section-title">
                            <div>
                                <span>成本分摊</span>
                            </div>
                        </div>
                        <div class="order-infoes">
                            <el-form :model="submitData" ref="formMsg" label-width="100px" style="width: 100%; padding-right: 30px">
                                <div class="form-main share-content" style="width: 100%">
                                    <el-form-item label="分摊类型">
                                        <el-select size="small" class="search-item" v-model="submitData.CalcType" disabled>
                                            <el-option v-for="item in calcTypeList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="分摊总额">
                                        <el-input-number size="small" disabled v-model="submitData.TotalAmount"></el-input-number>
                                    </el-form-item>
                                </div>
                                <div class="share-content">
                                    <div class="form-item" style="width: 100%">
                                        <el-form-item label="分摊项目">
                                            <div v-for="(item, index) in selfData" :key="index">
                                                <el-input style="width: 270px;" class="search-item" size="small" v-model="item.key" placeholder="请输入项目名称" disabled></el-input>
                                                <span style="margin: 0 16px">:</span>
                                                <el-input-number class="search-item" size="small" :min="0" v-model="item.value" placeholder="" disabled></el-input-number>
                                            </div>
                                        </el-form-item>
                                    </div>
                                </div>
                            </el-form>
                        </div>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="grid-content">
                        <div class="section-title">
                            <div>
                                <span>操作记录</span>
                            </div>
                        </div>
                        <div class="table-ctn">
                            <el-table
                                :header-cell-style="{ background: '#F2F6FC' }"
                                :data="actionRecords"
                                border=""
                                :max-height="250"
                                style="width: 100%; margin-bottom: 10px; margin-top: 0px"
                            >
                                <el-table-column fixed show-overflow-tooltip label="操作类型" prop="OpTypeName"> </el-table-column>
                                <el-table-column show-overflow-tooltip min-width="200" prop="Remark" label="操作说明"></el-table-column>
                                <el-table-column show-overflow-tooltip width="160" prop="CreateTime" label="操作时间"></el-table-column>
                                <el-table-column show-overflow-tooltip width="80" prop="Oper" label="操作人"></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <!--    table    -->
            <div class="section-title">
                <div>商品明细</div>
            </div>
            <!-- table body -->
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="dataList"
                    ref="multipleTable"
                    :summary-method="getSummaries"
                    show-summary
                    border=""
                    style="width: 100%"
                >
                    <el-table-column show-overflow-tooltip width="60px" type="index" label="序号"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="170px" prop="APCode" label="汽配编码">
                        <template slot-scope="scope">
                            <div class="apcode-cell">
                                <img class="info-icon" src="../../../assets/images/info.png" title="配件信息" @click.stop="showAPMsgDialog(scope.row.GoodsId)" />
                                <span>{{ scope.row.APCode }}</span>
                                <el-tag v-if="scope.row.State == 1" class="tag" type="warning" size="small">已删除</el-tag>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip min-width="200px" prop="GoodName" label="配件名称"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="160px" prop="AutoSerise" label="车型"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="90px" prop="Brand" v-if="isShowBrand" label="品牌" key="Brand"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="Origin" v-if="isOriginShow" label="产地" key="Origin"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="Size" v-if="isSizeShow" label="规格" key="Size"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" prop="Count" label="数量"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" prop="Price" label="采购价"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="ShareCost" label="分摊成本">
                        <template slot-scope="scope">
                            <i style="color: red" v-if="scope.row.ShareCost > 0">
                                {{ scope.row.ShareCost.toFixed(2) }}
                            </i>
                            <i v-else>{{ scope.row.ShareCost.toFixed(2) }}</i>
                        </template>
                    </el-table-column>
                    <el-table-column  width="100px" show-overflow-tooltip label="分摊总成本">
                        <template slot-scope="scope">
                            <i style="color: red" v-if="scope.row.ShareCost > 0">
                                {{ (scope.row.ShareCost * scope.row.Count).toFixed(2) }}
                            </i>
                            <i v-else>
                                {{ (scope.row.ShareCost * scope.row.Count).toFixed(2) }}
                            </i>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="120px" label="分摊后采购价">
                        <template slot-scope="scope">
                            {{ (scope.row.Price + scope.row.ShareCost).toFixed(2) }}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="120px" label="采购总计">
                        <template slot-scope="scope">
                            {{ ((scope.row.Price + scope.row.ShareCost) * scope.row.Count).toFixed(2) }}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" prop="IsInStorage" label="是否入仓">
                        <template slot-scope="scope">
                            <div v-if="scope.row.IsInStorage">
                                <span style="color:#ff0097">已入仓</span>
                            </div>
                            <div v-else>{{ scope.row.WarehousedCount > 0 ? '部分入仓' : '未入仓' }}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import APMsg from '@/components/common/APMsg';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        APMsg,
        breadcrumb
    },
    data() {
        return {
            loading: false,
            orderData: {},
            submitData: {
                OrderId: '',
                CalcType: 0,
                CostItems: '',
                IsUpdateCost: false,
                TotalAmount: 0
            },
            warehouseName: '',
            WarehouseAddr: '',
            id: '',
            pageTitle: '',
            permission: {},
            warehouse: [], //仓库地址
            dataList: [],
            paymentRecords: [],
            actionRecords: [],
            calcTypeList: [
                { Text: '按价值分摊', Value: 0 },
                { Text: '按数量分摊', Value: 1 }
            ],
            selfData: [
                // 自定义属性
            ],
            APMsgVisible: false,
            EntpTempGoodsIdEdit: '',
            dialogImageUrl: '',
            dialogImageVisible: false,
            orderImages: [],
            isOrgShow: false,
            isBPriceShow: false, //开单价
            isOriginShow: false, //产地
            isSizeShow: false, //规格
            CountSum: 0,
            PurPriceSum: 0,
            ShareCost: 0,
            ShareCostTotal: 0,
            AfterSCPrice: 0,
            TotalPur: 0,
            isShowBrand:false,//是否显示品牌
            isUseSource: false,
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    mounted() {
        this.getConfigByCodes().then(() => {
            this.id = this.$route.query.id;
            this.permission = this.$util.getPermission('supplierBuyOrder');
            this.submitData.OrderId = this.$route.query.id;
            this.getOrderDetail();
        });
    },
    methods: {
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['xskdxskdbm', 'xskdxskdj', 'kdspcd', 'kdspgg' ,'kdxspp', 'cgddly'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            let rValue = data[i].RValue;
                            switch (code) {
                                case 'xskdxskdbm':
                                    this.isOrgShow = result;
                                    break;
                                case 'xskdxskdj':
                                    this.isBPriceShow = result;
                                    break;
                                case 'kdspcd':
                                    this.isOriginShow = result;
                                    break;
                                case 'kdspgg':
                                    this.isSizeShow = result;
                                    break;
                                case 'kdxspp': //是否显示品牌
                                    this.isShowBrand = result;
                                    break;             
                                case 'cgddly': //是否启用采购开单显示来源
                                    this.isUseSource = result;
                                    break;                          
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        onUploadPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogImageVisible = true;
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
            if (edit) {
                this.getOrderDetail();
            }
        },
        // 获取详情
        getOrderDetail() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpPurchaseOrder/CheckEntpPurOrderAllDetails',
                    data: {
                        EntpCusPOId: this.id
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    this.orderData = data;
                    this.WarehouseAddr = data.ShipAddr;

                    if (data.Warehouse) {
                        this.warehouseName = data.Warehouse.WarehouseName;
                        if (!this.WarehouseAddr) this.WarehouseAddr = data.Warehouse.Address;
                    }
                    this.dataList = data.DetailList;
                    this.submitData.CalcType = data.CalcType;

                    this.paymentRecords = data.PaymentRecords;

                    this.actionRecords = data.ActionRecords;

                    this.orderImages = data.OrderImages;

                    for (let j = 0; j < this.orderImages.length; j++) {
                        this.orderImages[j].name = this.orderImages[j].Id;
                        this.orderImages[j].url = this.$util.QN_URL_BASE + this.orderImages[j].ImgUrl;
                    }

                    if (data.CostItems && data.CostItems.length > 0) {
                        this.selfData = data.CostItems;
                        this.calcShare();
                    }
                    let CountSum = 0;
                    let PurPriceSum = 0;
                    let ShareCost = 0;
                    let ShareCostTotal = data.CostAmount;
                    let AfterSCPrice = 0;
                    let TotalPur = 0;
                    this.dataList.forEach((e, i) => {
                        CountSum += e.Count * 1;
                        PurPriceSum += e.Price * 1;
                        ShareCost += e.ShareCost;
                        // ShareCostTotal += e.ShareCost * e.Count;
                        AfterSCPrice += e.ShareCost + e.Price;
                        TotalPur += (e.ShareCost + e.Price) * e.Count;
                    });
                    this.CountSum = CountSum;
                    this.PurPriceSum = PurPriceSum.toFixed(2);
                    this.ShareCost = ShareCost.toFixed(2);
                    this.ShareCostTotal = ShareCostTotal.toFixed(2);
                    this.AfterSCPrice = AfterSCPrice.toFixed(2);
                    this.TotalPur = TotalPur.toFixed(2);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        calcShare() {
            let that = this;
            let costTotal = 0;
            let supTotal = 0;
            let supCount = 0;
            let list = that.dataList;
            if (that.selfData.length > 0) {
                that.selfData.forEach(item => {
                    if (!isNaN(item.value)) {
                        costTotal += Number(item.value);
                    } else {
                        costTotal += 0;
                    }
                });
                if (costTotal > 0) {
                    that.submitData.TotalAmount = costTotal.toFixed(2);

                    // list.forEach(item => {
                    //     supTotal += item.Price;
                    //     supCount += item.Count;
                    // });

                    // that.dataList.forEach(item => {
                    //     if (that.submitData.CalcType == 0) {
                    //         item.ShareCost = Number((item.Price * (costTotal / supTotal)) / item.Count);
                    //     } else {
                    //         item.ShareCost = Number(costTotal / supCount);
                    //     }
                    // });
                } else {
                    that.submitData.TotalAmount = 0;
                    return;
                }
            }
        },
        getSummaries(param) {
            // const sums = [];
            // if (!this.isOriginShow && !this.isSizeShow) {
            //     return ['', '', '', `合计：`, this.CountSum, this.PurPriceSum, this.ShareCost, this.ShareCostTotal, this.AfterSCPrice, this.TotalPur,''];
            // } else if (this.isOriginShow && this.isSizeShow) {
            //     return ['', '', '','','', `合计：`, this.CountSum, this.PurPriceSum, this.ShareCost, this.ShareCostTotal, this.AfterSCPrice, this.TotalPur,''];
            // }  else {
            //    return ['', '', '','', `合计：`, this.CountSum, this.PurPriceSum, this.ShareCost, this.ShareCostTotal, this.AfterSCPrice, this.TotalPur,''];
            // }
            var countColIndex=0;
            countColIndex=param.columns.findIndex(item=>{ return item.label == '数量'});

            var arr=new Array(param.columns.length);
            if(countColIndex!=-1){
                arr[countColIndex]=this.CountSum;
                arr[countColIndex-1]="合计";
                arr[countColIndex+1]=this.PurPriceSum;
                arr[countColIndex+2]=this.ShareCost;
                arr[countColIndex+3]=this.ShareCostTotal;
                arr[countColIndex+4]=this.AfterSCPrice;
                arr[countColIndex+5]=this.TotalPur;
            }
            return arr;            
        },
        getSummaries_apply(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 2) {
                    let totalAmount = 0;
                    if (data.length > 0) totalAmount = Number(data[0].SumPayable);
                    let applyTotal = data.reduce((prev, curr) => {
                        if (curr.IsCancel) return prev;
                        else return prev + Number(curr.ApplyPay);
                    }, 0);
                    sums[index] = '剩余可申请：' + (totalAmount > applyTotal ? totalAmount - applyTotal : 0).toFixed(2);
                    return;
                } else if (index === 3) {
                    let sum = data.reduce((prev, curr) => {
                        if (curr.IsCancel || !curr.IsConfirm) return prev;
                        else return prev + Number(curr.NowPay);
                    }, 0);
                    sums[index] = '已付：' + sum.toFixed(2);
                    return;
                } else {
                    sums[index] = '';
                    return;
                }
            });

            return sums;
        }
    }
};
</script>
<style lang="less" scoped>
.form-uploadImg {
    margin-left: 30px;
}
.calc-btn {
    margin-left: 10px;
}
.payment-tip {
    position: absolute;
    left: 0;
    bottom: -18px;
    line-height: 1;
    font-size: 12px;
    color: @font4Color;
}
.search-ctn {
    border: 1px solid @border3Color;
    padding-top: 10px;
    margin-bottom: 10px;

    .el-form-item {
        margin-bottom: 10px;
    }
}
.form-main {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
}
.form-bottom {
    width: 100%;
    display: flex;
    flex-direction: row;
    div {
        width: 50%;
    }
}
.share-content {
    .el-form-item {
        margin-bottom: 8px;
    }
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}
.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }
}
.business-content-main {
    min-width: 1440px;
}
.table-main {
    position: relative;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.addresscls {
    display: flex;
    flex-direction: row;
}
.el-row {
    margin-bottom: 10px;
    &:last-child {
        margin-bottom: 0px;
    }
}
.apcode-cell {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .info-icon {
        margin-right: 10px;
    }
}
.tag {
    margin-left: 8px;
}
.bg-purple-dark {
    background: #99a9bf;
}
.bg-purple {
    background: #d3dce6;
}
.bg-purple-light {
    background: #e5e9f2;
}
.grid-content {
    border-radius: 4px;
    min-height: 36px;
}
</style>
<style lang="less">
// .el-col {
//   border-radius: 4px;
// }
// .el-row {
//   margin-bottom: 0px;
// }
.order-infoes {
    border: 1px solid @border3Color;
    padding-top: 10px;
    margin-bottom: 10px;

    .grid-content {
        border-radius: 4px;
        min-height: 32px;
    }
    .el-form-item {
        margin-bottom: 0px;
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__label {
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__content {
        line-height: 32px !important;
        height: 32px;
        top: -1px;
    }
}
</style>
